import { Box, Text } from "@mantine/core";
import classes from "./index.module.css";

/** Título e descrição: fixos, também no esqueleto. */
export function NotificationSoundHeader() {
  return (
    <Box>
      <Text
        component="h2"
        ff="heading"
        className={classes.title}>
        Som de notificação
      </Text>
      <Text className={classes.description}>
        Escolha em quais situações o sistema toca um som para avisar você.
        Desmarque as duas para ficar sem som.
      </Text>
    </Box>
  );
}
